import Animal from '../Entities/Animal';
import sort from 'array-sort';

const soriAnimalsByBioSecurityLocationAndMedicalTag = (animals: Animal[]) => {
  return sort(animals, [
    'locationEntity.bioSecurity',
    'locationEntity.name',
    'tagOrdinal',
  ]);
};

export default soriAnimalsByBioSecurityLocationAndMedicalTag;
